import React from 'react';
import { Phone, Mail, MessageCircle, Clock, Star, Award } from 'lucide-react';
import './Treatments.css';

const Treatments = () => {
  const therapists = [
    {
      name: 'Dr. Rahul Verma',
      degree: 'BPT, MPT (Orthopedics)',
      experience: '10+ Years',
      specialty: 'Back Pain & Spine Specialist',
      image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=400&h=400&fit=crop&crop=face',
      rating: 4.9,
    },
    {
      name: 'Dr. Anjali Sharma',
      degree: 'BPT, MPT (Neurology)',
      experience: '8+ Years',
      specialty: 'Stroke & Neuro Rehab',
      image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=400&h=400&fit=crop&crop=face',
      rating: 4.8,
    },
    {
      name: 'Dr. Vikram Patel',
      degree: 'BPT, MPT (Sports)',
      experience: '7+ Years',
      specialty: 'Sports Injury & Athlete Rehab',
      image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=400&h=400&fit=crop&crop=face',
      rating: 4.9,
    },
    {
      name: 'Dr. Priya Gupta',
      degree: 'BPT, MPT (Pediatrics)',
      experience: '6+ Years',
      specialty: 'Pediatric Physiotherapy',
      image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=400&h=400&fit=crop&crop=face',
      rating: 4.7,
    },
  ];

  const treatments = [
    {
      title: 'Manual Therapy',
      desc: 'Hands-on techniques including joint mobilization, soft tissue massage, and manipulation to relieve pain and restore movement.',
      duration: '45-60 min',
    },
    {
      title: 'Electrotherapy',
      desc: 'TENS, IFT, ultrasound, and laser therapy for pain relief, muscle stimulation, and accelerated tissue healing.',
      duration: '30-45 min',
    },
    {
      title: 'Exercise Therapy',
      desc: 'Customized exercise programs including stretching, strengthening, and proprioception training for long-term recovery.',
      duration: '45-60 min',
    },
    {
      title: 'Hydrotherapy',
      desc: 'Water-based rehabilitation exercises in specialized pools to reduce joint stress while building strength and flexibility.',
      duration: '30-45 min',
    },
  ];

  return (
    <div className="treatments-page">
      <section className="section">
        <div className="section-header">
          <h1>Meet Our Physiotherapists</h1>
          <p>Certified experts dedicated to your recovery and wellness</p>
        </div>
        <div className="therapists-grid">
          {therapists.map((therapist, i) => (
            <div className="therapist-card" key={i}>
              <div className="therapist-img-wrapper">
                <img className="therapist-img" src={therapist.image} alt={`${therapist.name} - ${therapist.specialty} at RV Physio Therapy Greater Noida`} />
              </div>
              <div className="therapist-info">
                <h3>{therapist.name}</h3>
                <p className="therapist-degree">{therapist.degree}</p>
                <p className="therapist-specialty">{therapist.specialty}</p>
                <div className="therapist-meta">
                  <span><Clock size={14} /> {therapist.experience}</span>
                  <span><Star size={14} fill="#f59e0b" /> {therapist.rating}</span>
                </div>
                <div className="therapist-social">
                  <a href="tel:+917048944596" title="Call"><Phone size={16} /></a>
                  <a href="mailto:contact@rvtechnologies.net.in" title="Email"><Mail size={16} /></a>
                  <a
                    href={`https://web.whatsapp.com/send?phone=917048944596&text=Hello, I would like to book an appointment with ${therapist.name} (${therapist.specialty}).`}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="WhatsApp"
                  >
                    <MessageCircle size={16} />
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Treatment Methods */}
        <div className="treatment-methods">
          <div className="section-header" style={{marginTop: '80px'}}>
            <h2>Our Treatment Methods</h2>
            <p>Evidence-based physiotherapy techniques for optimal recovery</p>
          </div>
          <div className="methods-grid">
            {treatments.map((t, i) => (
              <div className="method-card" key={i}>
                <div className="method-header">
                  <h3>{t.title}</h3>
                  <span className="method-duration"><Clock size={14} /> {t.duration}</span>
                </div>
                <p>{t.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Treatments;
